import { Point2D } from '@paragon/three-shared';

export const findPolarAngle = (pointA: Point2D, pointB: Point2D) => {
  const ONE_RADIAN = 57.295779513082;
  // if the points are undefined, return a zero difference angle.
  if (!pointA || !pointB) return 0;
  const deltaX = pointB.x - pointA.x;
  const deltaY = pointB.y - pointA.y;
  if (deltaX === 0 && deltaY === 0) {
    return 0;
  }
  let angle = Math.atan2(deltaY, deltaX) * ONE_RADIAN;
  if (angle < 0) {
    angle = Math.abs(angle);
    angle += 180;
  }
  return angle;
};
